import React from 'react'
import Subheader from '../../../component/Subheader'
import OtherRoom from '../../RoomDetail/OtherRoom';
import RoomBanner from '../../RoomDetail/RoomBanner';
import RoomQuote from '../../RoomDetail/RoomQuote';
import RoomCount from '../../RoomDetail/RoomCount';
import RoomGallery from '../../RoomDetail/RoomGallery';
import RoomEquipment from '../../RoomDetail/RoomEquipment';
import RoomBook from '../../RoomDetail/RoomBook';

export default function CorbettFamilycottages() {
    const heading = "Family Cottages";

    const subheadData = {
        heading: (
                    <>
                    <span className="sr-only">Corbett Room</span> {heading}
                    </>
                ),
        breadcrumb: [
            {
                slug: "/resort-de-coracao-corbett/room-listing",
                name: (
                        <>
                        <span className="sr-only">{heading}</span> Rooms
                        </>
                    ),
            },
            {
                slug: "",
                name: "Family Cottages",
            },
        ]
    }

    const roomBanner = {
        image: "/image/corbett-family-cortage-detail.webp",
    };

    const roomQuote = {
        content: "When you’re travelling with the whole crew, you need space and lots of it. The Family Cottage features two king-size beds, making it the perfect choice for larger families or a group of friends. It’s a spacious, shared sanctuary where you can swap stories about your tiger sightings and enjoy the togetherness that only a forest holiday can bring, all while experiencing comfortable stays.",
    };

    const roomCount = {
        bedroom: "1",
        bedsize: "2",
        area: "67",
        bathroom: "1",
        guest: "6",
        balcony: "1"
    };

    const roomGallery = [
        { image: "/image/corbett-family-cortage-gallery-1.webp" },
        { image: "/image/corbett-family-cortage-gallery-2.webp" },
        { image: "/image/corbett-family-cortage-gallery-3.webp" },
        { image: "/image/corbett-family-cortage-gallery-4.webp" },
        { image: "/image/corbett-family-cortage-gallery-5.webp" },
    ];

    const roomEquipment = {
        description: "Experience a comfortable retreat with spacious interiors and thoughtful facilities designed to make your stay effortless and enjoyable.",
        equipment: [
        [
            "Two King Size Beds for maximum sleeping space",
            "Comfortably fits up to 6 guests with extra mattress",
            "Tea and Coffee station for the whole family",
            "Mini-Refrigerator for drinks and snacks",
        ],
        [
            "Secure In-Room Electronic Safe",
            "Writing Desk with multiple electrical outlets",
            "High-speed Wi-Fi for all your devices",
            "Evening Turndown service to keep things comfy",
        ],
        [
            "Hydropneumatic high-pressure shower",
            "Soft, high-quality Cotton Bedding",
            "24-Hour Room Service availability",
        ]
    ]
    };

    const roomBook = {
        location: "Corbett",
        title: "Family Cottages",
        desc: "Make family time more comfortable at the spacious Family Cottages at De Coracao Corbett. With two king-size beds, generous interiors, and thoughtful amenities, these cottages are ideal for families and groups seeking a relaxed stay together after exciting days in the wilderness.",
        details: [
            "2 King Size Beds + 1 Extra Mattress Allowed",
            "Up to 6 Guests",
            "67 sq.mt"
        ],
        enquireLink: "/contact-us",
        bookLink: "https://www.swiftbook.io/inst/#home?propertyId=701Mn5Ca4GiFpRG7wK2385ZRnQ8BcTaRjrMkE4mjc5NQ==&JDRN=Y"
    };


    const otherRoom = {
        slides: [
            {
                title: 'Club Cottages',
                bg: '/image/corbett-other-room-1.webp',
                slug: '/resort-de-coracao-corbett/club-cottages',
                details: [
                    "1 King Size Bed + 1 Extra Mattress",
                    "Up to 4 Guests",
                    "42 sq.mt",
                ],
            },

            {
                title: 'Premium Cottages',
                bg: '/image/corbett-other-room-2.webp',
                slug: '/resort-de-coracao-corbett/premium-cottages',
                details: [
                    "1 King Size Bed + 1 Extra Mattress Allowed",
                    "Up to 3 Guests",
                    "41 sq.mt",
                ],
            },

            {
                title: 'Luxury Cottages',
                bg: '/image/corbett-other-room-3.webp',
                slug: '/resort-de-coracao-corbett/luxury-cottages',
                details: [
                    "1 King Size Bed + 1 Extra Mattress Allowed",
                    "Up to 3 Guests",
                    "41 sq.mt",
                ],
            },

            {
                title: 'Luxury Room',
                bg: '/image/corbett-other-room-4.webp',
                slug: '/resort-de-coracao-corbett/luxury-room',
                details: [
                    "1 King Size Bed + 1 Extra Mattress Allowed",
                    "Up to 3 Guests",
                    "37 sq.mt",
                ],
            },
        ],

        allRoom: { link: "/resort-de-coracao-corbett/room-listing" }
    }

    return (
        <>  
            <Subheader subheadData={subheadData} />
            <RoomBanner roomBanner={roomBanner} />
            <RoomQuote roomQuote={roomQuote} />
            <RoomCount roomCount={roomCount} />
            <RoomGallery roomGallery={roomGallery} />
            <RoomEquipment roomEquipment={roomEquipment} />
            <RoomBook roomBook={roomBook} />
            <OtherRoom otherRoom={otherRoom} roomTitle={`${roomBook.location} ${subheadData.heading}`}/>
        </>
    )
}
